import React, { FC } from 'react'
import { makeStyles, Typography } from 'transfix-ui/core'
import { AlertIcon } from 'transfix-icons'

const useStyles = makeStyles({
  missing: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    height: '100%',
    gap: 3,
  },
})

const MissingInfo: FC = () => {
  const styles = useStyles()
  return (
    <Typography variant='body1' className={styles.missing}>
      <AlertIcon color='error' size='large' />
      <span>missing</span>
    </Typography>
  )
}

export default MissingInfo
